import React from 'react';
import { TableColumnText } from '../table-column-text';
import { TableHeadProps } from './table-head-props';
import { cx } from '@mint/core';
import styled from 'styled-components';

/**
 * List root class name.
 */
const ROOT_CLASS_NAME = 'table-head';

/**
 * Component to use.
 */
const DEFAULT_COMPONENT = 'div';

/**
 * List component implementation before styling.
 */
export const TableHeadComponent = React.forwardRef<any, TableHeadProps>(
  (props, ref): React.ReactElement => {
    const {
      children,
      className,
      component: Component = DEFAULT_COMPONENT,
      ...rest
    } = props;

    const componentProps = {
      className: cx(ROOT_CLASS_NAME, className),
      ...rest,
      ref,
    };

    return <Component {...componentProps}>{children}</Component>;
  },
);

TableHeadComponent.displayName = 'TableHead';

export const TableHead = styled(TableHeadComponent)`
  ${TableColumnText} {
    font-weight: 500;
  }
`;
